"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useInputState = require("./useInputState");
Object.keys(_useInputState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useInputState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useInputState[key];
    }
  });
});